__turbopack_context__.v({
  "block": "monster-block-table-module__F7VxdG__block",
  "column": "monster-block-table-module__F7VxdG__column",
  "firstLine": "monster-block-table-module__F7VxdG__firstLine",
  "header": "monster-block-table-module__F7VxdG__header",
  "mod": "monster-block-table-module__F7VxdG__mod",
  "secondLine": "monster-block-table-module__F7VxdG__secondLine",
  "statName": "monster-block-table-module__F7VxdG__statName",
});
